import Vue from "vue";
import Router from "vue-router";
import Entry from "./views/entry/index.vue";
import Store from "@/store";
// import Request from "@/assets/js/request.js";
import { i18n } from "@/i18n";
import { Message } from "element-ui";
import cookie from "@/assets/js/cookie";
import Filter from "@/assets/js/filter.js";
// Sentry未使用
// import * as Sentry from '@sentry/browser';

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: "/entry",
  },
  {
    path: "/entry",
    component: Entry,
  },
  // 无权限页
  {
    path: "/401",
    meta: {
      role: "all",
    },
    component: () => import("./views/errorPage/401"),
  },
  // 内部管理界面
  {
    path: "/adminNewStatr",
    meta: {
      role: [15],
      version: [1],
    },
    // 异步加载路由的第二种写法
    component: () => import("./views/adminNewStatr"),
    children: [
      {
        path: "",
        redirect: "home",
      },
      // 系统设置
      {
        path: "/adminNewStatr/home",
        component: () => import("./views/adminNewStatr/overview/indexnew"),
        meta: {
          title: i18n.t("menu.setting"),
          icon: "icon-shezhi1",
          iconnew: "icon-shezhi1",
          category: {
             //用户管理
             accountManagement: {
               title: i18n.t("menu.account"),
               icon: "icon-a-mingchengyonghushuxingyuanjiao3",
               name: "accountManagement",
             },
            //厂家管理
            factoryManagement: {
              title: i18n.t("menu.Manufacturer"),
              icon: "icon-shucaiqi",
              name: "factoryManagement",
            },
            // 数采器管理
            digitizerManagement: {
              title: i18n.t("menu.datalogger"),
              icon: "icon-a-mingchengcaijiqishezhi2",
              name: "digitizerManagement",
            },
            // API接口界面
            APIInterfaceInterface: {
              title: i18n.t("menu.AIP_Interface"),
              icon: "icon-shucaiqi",
              name: "APIInterfaceInterface",
            },
            //协议操作工具
            ProtocolOperationTools: {
              title: i18n.t("menu.protocol_operation"),
              icon: "icon-shucaiqi",
              name: "ProtocolOperationTools",
            },
            //充值管理
            rechargeManagement: {
              title: i18n.t("menu.recharge_management"),
              icon: "icon-recharge",
              name: "rechargeManagement",
            },
            //设备管理
            deviceManagement: {
              title: i18n.t("menu.device_management"),
              icon: "icon-shebei",
              name: "deviceManagement",
            },
          },
        },
        children: [
          {
            path: "",
            redirect: "account",
          },
          {
            path: "account",
            name: "adminAccount",
            component: () => import("./views/adminNewStatr/overview/account"),
            meta: {
              title: i18n.t("account.accountList"),
              icon: "icon-a-mingchengyonghushuxingyuanjiao3",
              category: 'accountManagement'
            },
          },
          {
            path: "device",
            name: "adminDevice",
            component: () => import("./views/adminNewStatr/overview/device"),
            meta: {
              title: i18n.t("device.deviceList"),
              icon: "icon-shebei",
              category: 'deviceManagement'
            },
          },
          //数采器列表
          {
            path: "datalogger",
            name: "adminDatalogger",
            component: () => import("./views/adminNewStatr/overview/digitizerManagement/dataloggerList"),
            meta: {
              title: i18n.t("menu.datalogger_list"),
              icon: "icon-workOrder",
              category: 'digitizerManagement'
            },
          },
          //数采器日志
          {
            path: "log",
            name: "adminLog",
            component: () => import("./views/adminNewStatr/overview/digitizerManagement/log"),
            meta: {
              title: i18n.t("menu.log"),
              icon: "icon-a-mingchengrizhishuxingbijiben3",
              category: 'digitizerManagement'
            },
          },
          //数采器解绑记录
          {
            path: "dataloggerUnbindingRecord",
            name: "adminDataloggerUn",
            component: () => import("./views/adminNewStatr/overview/digitizerManagement/dataloggerUnbindingRecord"),
            meta: {
              title: i18n.t("colUnBindRecord.UnBindRecord"),
              icon: "icon-a-mingchengrizhishuxingbijiben3",
              category: 'digitizerManagement'
            },
          },
         // 数采器协议绑定
         {
           path: "protocolBinding",
           name: "protocolBinding",
           component: () => import("./views/adminNewStatr/overview/digitizerManagement/protocolBinding"),
           meta: {
             title: i18n.t("menu.protocol_binding"),
             category: "digitizerManagement",
             icon: "icon-plant",
           },
         },
         // 数采器类型编码
         {
           path: "typeCode",
           name: "typeCode",
           component: () => import("./views/adminNewStatr/overview/digitizerManagement/typeCode"),
           meta: {
             title: i18n.t("menu.type_code"),
             category: "digitizerManagement",
             icon: "icon-cloud-plus",
           },
         },
         // 数采器协议更改
         {
           path: "protocolChange",
           name: "protocolChange",
           component: () => import("./views/adminNewStatr/overview/digitizerManagement/protocolChange"),
           meta: {
             title: i18n.t("menu.protocol_change"),
             category: "digitizerManagement",
             icon: "icon-a-mingchengtianjiabuju",
           },
         },
          // 操作日志
          {
            path: "actionLog",
            name: "adminNewActionLog",
            component: () => import("./views/adminNewStatr/overview/actionLog"),
            meta: {
              title: i18n.t("menu.actionLog"),
              icon: 'icon-rili',
              category: 'accountManagement'
            },
          },
          //厂家账号
          {
            path: "factoryAccount",
            name: "factoryAccount",
            component: () => import("./views/adminNewStatr/overview/factoryManagement/factoryAccount"),
            meta: {
              title: i18n.t("menu.manufacturer_account"),
              category: "factoryManagement",
              icon: "icon-liuliangchongzhi",
            },
          },
          // 厂家编码
          {
            path: "factoryCode",
            name: "factoryCode",
            component: () => import("./views/adminNewStatr/overview/factoryManagement/factoryCode"),
            meta: {
              title: i18n.t("menu.manufacturer_code"),
              category: "factoryManagement",
              icon: "icon-chongzhijilu",
            },
          },
          // API接口界面
          // KEY列表
          {
            path: "KEYList",
            name: "KEYList",
            component: () => import("./views/adminNewStatr/overview/APIInterfaceInterface/KEYList"),
            meta: {
              title: i18n.t("menu.KEY_List"),
              category: "APIInterfaceInterface",
              icon: "icon-chongzhijilu",
            },
          },
          // 协议操作工具
          // 协议指令管理
          {
            path: "protocolInstruction",
            name: "protocolInstruction",
            component: () => import("./views/adminNewStatr/overview/ProtocolOperationTools/protocolInstruction"),
            meta: {
              title: i18n.t("menu.Protocol_instruction"),
              category: "ProtocolOperationTools",
              icon: "icon-chongzhijilu",
            },
          },
          // 原始数据解析
          {
            path: "rawDataParsing",
            name: "rawDataParsing",
            component: () => import("./views/adminNewStatr/overview/ProtocolOperationTools/rawDataParsing"),
            meta: {
              title: i18n.t("menu.Raw_data"),
              category: "ProtocolOperationTools",
              icon: "icon-chongzhijilu",
            },
          },
          // 充值管理
          // 充值补救
          {
            path: "rechargeRemedy",
            name: "rechargeRemedy",
            component: () => import("./views/adminNewStatr/overview/rechargeManagement/rechargeRemedy"),
            meta: {
              title: i18n.t("menu.Recharge_remedy"),
              category: "rechargeManagement",
              icon: "icon-chongzhijilu",
            },
          },
          // 设备管理
          // 设备管理功能
          {
            path: "deviceFunction",
            name: "deviceFunction",
            component: () => import("./views/adminNewStatr/overview/deviceManagement/deviceFunction"),
            meta: {
              title: i18n.t("menu.device_function"),
              category: "deviceManagement",
              icon: "icon-chongzhijilu",
            },
          },
          // 控制项密码维护
          {
            path: "passwordMaintenance",
            name: "passwordMaintenance",
            component: () => import("./views/adminNewStatr/overview/deviceManagement/passwordMaintenance"),
            meta: {
              title: i18n.t("menu.Password_maintenance"),
              category: "deviceManagement",
              icon: "icon-chongzhijilu",
            },
          },
        ]
      },
    ]
  },
  // 管理员页面新版
  {
    path: "/adminNew",
    meta: {
      role: [1, 2, 3],
      version: [1],
    },
    // 异步加载路由的第二种写法
    component: () => import("./views/adminNew"),
    children: [
      {
        path: "",
        redirect: "home",
      },
      // 总览
      {
        // path: '/adminNew/device',
        path: "/adminNew/home",
        component: () => import("./views/adminNew/overview/indexnew"),
        meta: {
          title: i18n.t("menu.overview"),
          icon: "icon-a-mingchengzonglan",
          iconnew: "icon-a-mingchengzonglan",
        },
      },
      // 设备管理
      {
        path: "/adminNew/device",
        // path: '/adminNew/home',
        component: () => import("./views/adminNew/device/indexnew"),
        meta: {
          title: i18n.t("menu.device"),
          icon: "icon-zongzhuangjirongliang",
          iconnew: "icon-shebei",
        },
      },
      // 账号管理
      {
        path: "/adminNew/account",
        component: () => import("./views/adminNew/account/indexnew"),
        meta: {
          title: i18n.t("menu.account"),
          icon: "icon-yonghuguanli",
          iconnew: "icon-yonghuguanli1",
        },
      },
      // 告警管理
      {
        path: "/adminNew/alarm",
        component: () => import("./views/alarmsnew"),
        meta: {
          title: i18n.t("menu.alarm"),
          icon: "icon-gaojingguanli",
          iconnew: "icon-gaojing",
        },
      },
      // 归档历史记录
      {
        path: "/adminNew/alarm/archiveHistory",
        component: () => import("./views/archiveHistory/ManufacturerarchiveHistory"),
        meta: {
          title: "归档历史记录",
          icon: "icon-gaojingguanli",
          iconnew: "icon-gaojing",
        },
      },
      // 项目管理
      {
        path: "/adminNew/project",
        component: () => import("./views/projectnew"),
        meta: {
          // title: i18n.t('menu.alarm'),
          title: "项目管理",
          icon: "icon-gaojingguanli",
        },
      },
      // 个人中心
      {
        path: "/adminNew/personalBasic",
        name: "adminNewPersonalBasic",
        component: () => import("./views/settingNew/personal/basicnew"),
        meta: {
          title: i18n.t("menu.basic"),
          // category: 'personal',
          // title: '基本信息',
          icon: "icon-firmwareSet",
        },
      },
      // 系统设置
      {
        path: "/adminNew/setting",
        component: () => import("./views/settingNew/indexnew"),
        meta: {
          title: i18n.t("menu.setting"),
          icon: "icon-xitongshezhi",
          // iconnew: 'icon-xitongshezhi-new',
          iconnew: "icon-shezhi",
          category: {
            // firmwarenew: {
            //   title: i18n.t("menu.firmwarenew"),
            //   icon: "icon-gujian",
            //   // 增(默认选中首个)
            //   // path: '/adminNew/setting/rechargePay',
            //   name: "firmwarenew",
            // },
            personal: {
              title: i18n.t("menu.personal"),
              icon: "icon-accountSet",
            },
            alarm: {
              title: i18n.t("menu.alarmSetting"),
              icon: "icon-alarmSet",
            },
            recharge: {
              title: i18n.t("menu.recharge"),
              icon: "icon-chongzhiguanli",
              // 增(默认选中首个)
              // path: '/adminNew/setting/rechargePay',
              name: "recharge",
            },
            strategynew: {
              title: i18n.t("menu.strategy"),
              icon: "icon-caozuo_tiaoshi",
              // 增(默认选中首个)
              // path: '/adminNew/setting/rechargePay',
              name: "strategynew",
            },
          },
        },
        children: [
          {
            path: "",
            // personalBasic
            // datalogger
            redirect: "firmware",
          },
          // 数采器管理
          {
            path: "datalogger",
            name: "adminNewDatalogger",
            component: () => import("./views/settingNew/dataloggernew"),
            meta: {
              title: i18n.t("menu.datalogger"),
              icon: "icon-shucaiqi",
            },
          },
          // 固件管理
          {
            path: "firmware",
            name: "adminNewFirmware",
            component: () => import("./views/settingNew/firmwarenew"),
            meta: {
              title: i18n.t("menu.firmware"),
              icon: 'icon-gujian'
              // icon:
              //   "icon-a-mingchenggujianshengjiyangshishuangsexianxingtubiao",
              // category: "firmwarenew",
            },
          },

          // 充值管理-流量充值
          {
            path: "rechargePay",
            name: "adminNewRechargePay",
            component: () => import("./views/settingNew/recharge/paynew"),
            meta: {
              title: i18n.t("menu.pay"),
              category: "recharge",
              icon: "icon-liuliangchongzhi",
            },
          },
          // 充值管理-充值记录
          {
            path: "rechargeRecord",
            name: "adminNewRechargeRecord",
            component: () => import("./views/settingNew/recharge/recordnew"),
            meta: {
              title: i18n.t("menu.record"),
              category: "recharge",
              icon: "icon-chongzhijilu",
            },
          },
          // 充值管理-采集频率升级订单记录
          {
            path: "collectionFrequencyRecord",
            name: "adminNewCollectionFrequencyRecord",
            component: () => import("./views/settingNew/recharge/collectionFrequencyRecord"),
            meta: {
              title: i18n.t("collectionFrequencyUP.collect_Order_Record"),
              category: "recharge",
              icon: "icon-chongzhijilu",
            },
          },
          // 费率管理
          {
            path: "rate",
            name: "adminNewRate",
            component: () => import("./views/settingNew/ratenew"),
            meta: {
              title: i18n.t("menu.rate"),
              icon: "icon-fee",
            },
          },
          // 辅助功能
          {
            path: "helpform",
            name: "adminHelpform",
            component: () => import("./views/settingNew/helpformnew"),
            meta: {
              title: i18n.t("auxiliary.auxiliaryFunction"),
              // title: '辅助功能',
              icon: "icon-shezhi",
            },
          },
          // 固件管理
          {
            path: "adaptiveFirmware",
            name: "adaptiveFirmware",
            component: () => import("./views/settingNew/adaptiveFirmware"),
            meta: {
              title: i18n.t("menu.adaptiveFirmware"),
              // icon: 'icon-gujian'
              icon: "icon-cloud-plus",
              // icon: 'icon-xitongshezhi'
              // icon:
              //   "icon-a-mingchenggujianshengjiyangshishuangsexianxingtubiao",
              // category: "firmwarenew",
            },
          },
          // UPG固件管理(日月元OAT复用 请勿更改)
          {
            path: "UpgFirmware",
            name: "adminUpgFirmware",
            component: () => import("./views/settingNew/UpgFirmwarenew"),
            meta: {
              title: i18n.t("strategy.UpgFirmware"),
              category: "strategynew",
              icon: "icon-gujian",
            },
          },
               // 日月元本地策略功能（方便后续定制）
          {
            path: "energyFirmware",
            name: "adminenergyFirmware",
            component: () => import("./views/settingNew/energyFirmware"),
            meta: {
              title: i18n.t("firmware.Firmware_List"),
              category: "strategynew",
              icon: "icon-gujian",
            },
          },
          // 本地策略功能
          {
            path: "strategy",
            name: "adminStrategy",
            component: () => import("./views/settingNew/strategynew"),
            meta: {
              title: i18n.t("strategy.strategyUpgrade"),
              category: "strategynew",
              icon: "icon-btn_drawremark",
            },
          },
          // 日月元本地策略功能（方便后续定制）
          {
            path: "energyStrategynew",
            name: "adminEnergyStrategynew",
            component: () => import("./views/settingNew/energyStrategynew"),
            meta: {
              title: i18n.t("strategy.strategyUpgrade"),
              category: "strategynew",
              icon: "icon-btn_drawremark",
            },
          },
          // 升级记录
          {
            path: "upgrade",
            name: "adminUpgrade",
            component: () => import("./views/settingNew/upgrade"),
            meta: {
              title: i18n.t("strategy.upgradeList"),
              category: "strategynew",
              icon: "icon-a-mingchenggongdanshuxinggongdanliebiao2",
            },
          },
          // 日月元升级记录（方便后续定制）
          {
            path: "energyUpgrade",
            name: "adminEnergyUpgrade",
            component: () => import("./views/settingNew/energyUpgrade"),
            meta: {
              title: i18n.t("strategy.upgradeList"),
              category: "strategynew",
              icon: "icon-a-mingchenggongdanshuxinggongdanliebiao2",
            },
          },
          // // 添加策略功能
          // {
          //   path: "addstrategy",
          //   name: "adminaddStrategy",
          //   component: () => import("./views/settingNew/addstrategynew"),
          // },
          // // 策略详情
          // {
          //   path: "viewstrategy",
          //   name: "adminviewstrategy",
          //   component: () => import("./views/settingNew/viewstrategynew"),
          // },
          // 日月元透传升级
          // 云端固件管理
          // {
          //   path: "cloudsFirmware",
          //   name: "adminCloudsFirmware",
          //   component: () => import("./views/settingNew/cloudsFirmwarenew"),
          //   meta: {
          //     title: i18n.t("cloudsUpgarde.cloudsFirmware"),
          //     // category: "firmwarenew",
          //     // icon: "icon-caozuo_shengji",
          //     icon: 'icon-gujian'
          //   },
          // },
          // 换肤
          // {
          //   path: 'customize',
          //   name: 'adminCustomize',
          //   component: () =>
          //     import('./views/settingNew/customize'),
          //   meta: {
          //     title: i18n.t('menu.customize'),
          //     icon: 'icon-set'
          //   }
          // },
        ],
      },
    ],
  },
  // 管理员页面旧版
  {
    path: "/admin",
    meta: {
      role: [1, 2, 3],
      version: [0],
    },
    // 异步加载路由的第二种写法
    component: () => import("./views/admin"),
    children: [
      {
        path: "",
        redirect: "home",
      },
      {
        path: "/admin/home",
        component: () => import("./views/admin/home/index"),
        meta: {
          title: i18n.t("menu.home"),
          icon: "icon-shouyedianji",
          // iconnew: 'icon-shouyedianji-new',
          iconnew: "icon-shebei",
        },
      },
      {
        path: "/admin/account",
        component: () => import("./views/admin/account/index"),
        meta: {
          title: i18n.t("menu.account"),
          icon: "icon-yonghuguanli",
        },
      },
      {
        path: "/admin/device",
        component: () => import("./views/admin/device/index"),
        meta: {
          title: i18n.t("menu.device"),
          icon: "icon-zongzhuangjirongliang",
        },
      },
      {
        path: "/admin/alarm",
        component: () => import("./views/alarm"),
        meta: {
          title: i18n.t("menu.alarm"),
          icon: "icon-gaojingguanli",
        },
      },
      {
        path: "/admin/setting",
        component: () => import("./views/setting/index"),
        meta: {
          title: i18n.t("menu.setting"),
          icon: "icon-xitongshezhi",
          // iconnew: 'icon-xitongshezhi-new',
          iconnew: "icon-gongneng",
          category: {
            personal: {
              title: i18n.t("menu.personal"),
              icon: "icon-accountSet",
            },
            alarm: {
              title: i18n.t("menu.alarmSetting"),
              icon: "icon-alarmSet",
            },
            recharge: {
              title: i18n.t("menu.recharge"),
              icon: "icon-rechargeSet",
            },
          },
        },
        children: [
          {
            path: "",
            redirect: "personalBasic",
          },
          {
            path: "personalBasic",
            name: "adminPersonalBasic",
            component: () => import("./views/setting/personal/basic"),
            meta: {
              title: i18n.t("menu.basic"),
              category: "personal",
            },
          },
          // {
          //   path: 'personalPassword',
          //   name: 'adminPersonalPassword',
          //   component: () =>
          //     import('./views/setting/personal/password'),
          //   meta: {
          //     title: i18n.t('menu.password'),
          //     category: 'personal'
          //   }
          // },
          // {
          //   path: 'alarmEmail',
          //   name: 'adminAlarmEmail',
          //   component: () =>
          //     import('./views/setting/alarm/email'),
          //   meta: {
          //     title: i18n.t('menu.email'),
          //     category: 'alarm'
          //   }
          // },
          // {
          //   path: 'alarmMobile',
          //   name: 'adminAlarmMobile',
          //   component: () =>
          //     import('./views/setting/alarm/mobile'),
          //   meta: {
          //     title: i18n.t('menu.mobile'),
          //     category: 'alarm'
          //   }
          // },
          {
            path: "rechargePay",
            name: "adminRechargePay",
            component: () => import("./views/setting/recharge/pay"),
            meta: {
              title: i18n.t("menu.pay"),
              category: "recharge",
            },
          },
          // {
          //   path: 'rechargeRecord',
          //   name: 'adminRechargeRecord',
          //   component: () =>
          //     import('./views/setting/recharge/record'),
          //   meta: {
          //     title: i18n.t('menu.record'),
          //     category: 'recharge'
          //   }
          // },
          // {
          //   path: 'rate',
          //   name: 'adminRate',
          //   component: () =>
          //     import('./views/setting/rate'),
          //   meta: {
          //     title: i18n.t('menu.rate'),
          //     icon: 'icon-fee'
          //   }
          // },
          {
            path: "firmware",
            name: "adminFirmware",
            component: () => import("./views/setting/firmware"),
            meta: {
              title: i18n.t("menu.firmware"),
              icon: "icon-firmwareSet",
            },
          },
          {
            path: "customize",
            name: "adminCustomize",
            component: () => import("./views/setting/customize"),
            meta: {
              title: i18n.t("menu.customize"),
              icon: "icon-set",
            },
          },
        ],
      },
    ],
  },
  //普通用户页面新版
  {
    path: "/generalNew",
    meta: {
      role: [0, 5],
      version: [1],
    },
    component: () => import("./views/generalNew"),
    children: [
      {
        path: "",
        redirect: "home",
      },
      {
        path: "/generalNew/home",
        component: () => import("./views/generalNew/device/index"),
        meta: {
          title: i18n.t("menu.myDevice"),
          icon: "icon-shouyedianji",
          // iconnew: 'icon-shouyedianji-new',
          iconnew: "icon-shebei",
        },
      },
      {
        path: "/generalNew/alarm",
        component: () => import("./views/alarm"),
        meta: {
          title: i18n.t("menu.alarm"),
          icon: "icon-gaojingguanli",
        },
      },
      // 归档历史记录
      {
        path: "/generalNew/alarm/archiveHistory",
        component: () => import("./views/archiveHistory/ManufacturerarchiveHistory"),
        meta: {
          title: "归档历史记录",
          icon: "icon-gaojingguanli",
        },
      },
      // 无设备
      {
        path: "/generalNew/deviceno",
        component: () => import("./views/generalNew/device/deviceno"),
        meta: {
          // title: i18n.t('menu.alarm'),
          // icon: 'icon-gaojingguanli'
        },
      },
      // 新手指引
      {
        path: "/generalNew/generalintro",
        component: () => import("./views/introNew/generalIntroNew"),
        meta: {
          // title: i18n.t('menu.alarm'),
          // icon: 'icon-gaojingguanli'
        },
      },
      // 项目管理
      {
        path: "/generalNew/project",
        component: () => import("./views/projectnew"),
        meta: {
          // title: i18n.t('menu.alarm'),
          title: "项目管理",
          icon: "icon-gaojingguanli",
        },
      },
      // 个人中心
      {
        path: "/generalNew/personalBasic",
        name: "generalNewPersonalBasic",
        component: () => import("./views/settingNew/personal/basicnew"),
        meta: {
          title: i18n.t("basic.basicInfo"),
          // category: 'personal',
          // title: '基本信息',
          icon: "icon-firmwareSet",
        },
      },
      {
        path: "/generalNew/setting",
        component: () => import("./views/settingNew/indexnew"),
        meta: {
          title: i18n.t("menu.functionalApplication"),
          icon: "icon-xitongshezhi",
          // iconnew: 'icon-xitongshezhi-new',
          iconnew: "icon-gongneng",
          category: {
            // 数采器管理
            datalogger: {
              title: i18n.t("menu.datalogger"),
              icon: "icon-shucaiqi",
            },
            personal: {
              title: i18n.t("menu.personal"),
              icon: "icon-accountSet",
            },
            alarm: {
              title: i18n.t("menu.alarmSetting"),
              icon: "icon-alarmSet",
            },
            recharge: {
              title: i18n.t("menu.recharge"),
              icon: "icon-chongzhiguanli",
              // 增(默认选中首个)
              // path: '/generalNew/setting/rechargePay',
              name: "recharge",
            },
            billing: {
              title: i18n.t("rosRecharge.electronicInvoicing"),
              icon: "icon-invoiceList",
              name: "billing",
            },
            // 报表管理
            report: {
              title: i18n.t("settingalarm.Receiving_Report"),
              // title: '报表管理',
              icon: "icon-baobiao",
              name: "report",
            },
          },
        },
        children: [
          {
            path: "",
            redirect: "datalogger",
          },
          // 数采器管理
          {
            path: "datalogger",
            name: "generalDatalogger",
            component: () => import("./views/settingNew/dataloggernew"),
            meta: {
              title: i18n.t("menu.datalogger"),
              // icon: 'icon-shucaiqi'
              icon: "icon-a-mingchengcaijiqishezhi3",
            },
          },
          // {
          //   path: 'personalPassword',
          //   name: 'generalPersonalPassword',
          //   component: () =>
          //     import('./views/settingNew/personal/password'),
          //   meta: {
          //     title: i18n.t('menu.password'),
          //     category: 'personal'
          //   }
          // },
          // {
          //   path: 'alarmEmail',
          //   name: 'generalAlarmEmail',
          //   component: () =>
          //     import('./views/settingNew/alarm/email'),
          //   meta: {
          //     title: i18n.t('menu.email'),
          //     category: 'alarm'
          //   }
          // },
          // {
          //   path: 'alarmMobile',
          //   name: 'generalAlarmMobile',
          //   component: () =>
          //     import('./views/settingNew/alarm/mobile'),
          //   meta: {
          //     title: i18n.t('menu.mobile'),
          //     category: 'alarm'
          //   }
          // },
          // 充值管理-流量充值 [Duplicate named]
          {
            path: "rechargePay",
            name: "generalNewRechargePay",
            component: () => import("./views/settingNew/recharge/paynew"),
            meta: {
              title: i18n.t("menu.pay"),
              category: "recharge",
              icon: "icon-liuliangchongzhi",
            },
          },
          // 充值管理-充值记录
          {
            path: "rechargeRecord",
            name: "generalNewRechargeRecord",
            component: () => import("./views/settingNew/recharge/recordnew"),
            meta: {
              title: i18n.t("menu.record"),
              category: "recharge",
              icon: "icon-chongzhijilu",
            },
          },
          // 充值管理-采集频率升级订单记录
          {
            path: "collectionFrequencyRecord",
            name: "generalNewCollectionFrequencyRecord",
            component: () => import("./views/settingNew/recharge/collectionFrequencyRecord"),
            meta: {
              title: i18n.t("collectionFrequencyUP.collect_Order_Record"),
              category: "recharge",
              icon: "icon-chongzhijilu",
            },
          },
          // 电子开票列表
          {
            path: "billingList",
            name: "generalNewBillingList",
            component: () => import("./views/settingNew/billing/billingList"),
            meta: {
              title: i18n.t("rosRecharge.issueEInvoice"),
              category: "billing",
              icon: "icon-invoiceList1",
            },
          },
          // 开票历史
          {
            path: "billingHistory",
            name: "generalNewBillingHistory",
            component: () => import("./views/settingNew/billing/billingHistory"),
            meta: {
              title: i18n.t("rosRecharge.invoiceHistory"),
              category: "billing",
              icon: "icon-billingHistory",
            },
          },
          // 固件管理 [Duplicate named]
          {
            path: "firmware",
            name: "generalNewFirmware",
            component: () => import("./views/settingNew/firmwarenew"),
            meta: {
              title: i18n.t("menu.firmware"),
              icon: "icon-a-mingchenggujianguanli",
            },
          },
          // 告警管理
          {
            path: "alarmform",
            name: "generalAlarmform",
            component: () => import("./views/settingNew/alarmformnew"),
            meta: {
              title: i18n.t("menu.alarm"),
              // title: '告警管理',
              icon: "icon-gaojing",
            },
          },
          // 报表管理-导出报表
          {
            path: "reportexport",
            name: "generalReportExport",
            component: () => import("./views/settingNew/report/exportnew"),
            meta: {
              title: i18n.t("report.Export_report"),
              // title: '导出报表',
              icon: "icon-baobiao",
              category: "report",
            },
          },
          // 报表管理-订阅报表
          {
            path: "reportsubscribe",
            name: "generalReportSubscribe",
            component: () => import("./views/settingNew/report/subscribenew"),
            meta: {
              title: i18n.t("report.Subscribe_report"),
              // title: '订阅报表',
              icon: "icon-baobiao",
              category: "report",
            },
          },
          // 费率管理 [Duplicate named]
          {
            path: "rate",
            name: "generalNewRate",
            component: () => import("./views/settingNew/ratenew"),
            meta: {
              title: i18n.t("menu.rate"),
              icon: "icon-feishuaiguanli",
            },
          },
          // 辅助功能
          {
            path: "helpform",
            name: "generalHelpform",
            component: () => import("./views/settingNew/helpformnew"),
            meta: {
              title: i18n.t("auxiliary.auxiliaryFunction"),
              // title: '辅助功能',
              icon: "icon-shezhi",
            },
          },
          // 子账号管理
          {
            path: 'browseAccount',
            name: 'generalBrowseAccount',
            component: () =>
              import('./views/settingNew/browseAccount'),
            meta: {
              title: i18n.t('menu.browseAccount'),
              // icon: 'icon-shucaiqi'
              icon: 'icon-a-mingchengyonghushuxingmoren2'
            }
          },
          // // 添加子账号功能
          // {
          //   path: 'addBrowse',
          //   name: 'generaladdBrowse',
          //   component: () =>
          //     import('./views/settingNew/addBrowsenew'),
          // },
          // // 编辑子账号功能
          // {
          //   path: 'editBrowse',
          //   name: 'generaleditBrowse',
          //   component: () =>
          //     import('./views/settingNew/editBrowsenew'),
          // },
          // 个人中心-个人信息
          // {
          //   path: 'personalBasic',
          //   name: 'generalPersonalBasic',
          //   component: () =>
          //     import('./views/settingNew/personal/basicnew'),
          //   meta: {
          //     // title: i18n.t('menu.basic'),
          //     // category: 'personal',
          //     title: '个人信息',
          //     icon: 'icon-firmwareSet'
          //   }
          // },
          // 个人中心-账户安全
          // {
          //   path: 'personalPassword',
          //   name: 'generalPersonalPassword',
          //   component: () =>
          //     import('./views/settingNew/personal/passwordnew'),
          //   meta: {
          //     // title: i18n.t('menu.password'),
          //     // category: 'personal',
          //     title: '账户安全',
          //     icon: 'icon-firmwareSet'
          //   }
          // },
        ],
      },
    ],
  },
  // 普通用户页面旧版
  {
    path: "/general",
    meta: {
      role: [0, 5],
      version: [0],
    },
    component: () => import("./views/general"),
    children: [
      {
        path: "",
        redirect: "home",
      },
      {
        path: "/general/home",
        component: () => import("./views/general/device/index"),
        meta: {
          title: i18n.t("menu.home"),
          icon: "icon-shouyedianji",
        },
      },
      {
        path: "/general/alarm",
        component: () => import("./views/alarm"),
        meta: {
          title: i18n.t("menu.alarm"),
          icon: "icon-gaojingguanli",
        },
      },
      {
        path: "/general/setting",
        component: () => import("./views/setting/index"),
        meta: {
          title: i18n.t("menu.setting"),
          icon: "icon-xitongshezhi",
          category: {
            personal: {
              title: i18n.t("menu.personal"),
              icon: "icon-accountSet",
            },
            alarm: {
              title: i18n.t("menu.alarmSetting"),
              icon: "icon-alarmSet",
            },
            recharge: {
              title: i18n.t("menu.recharge"),
              icon: "icon-rechargeSet",
            },
          },
        },
        children: [
          {
            path: "",
            redirect: "personalBasic",
          },
          {
            path: "personalBasic",
            name: "generalPersonalBasic",
            component: () => import("./views/setting/personal/basic"),
            meta: {
              title: i18n.t("menu.basic"),
              category: "personal",
            },
          },
          // {
          //   path: 'personalPassword',
          //   name: 'generalPersonalPassword',
          //   component: () =>
          //     import('./views/setting/personal/password'),
          //   meta: {
          //     title: i18n.t('menu.password'),
          //     category: 'personal'
          //   }
          // },
          // {
          //   path: 'alarmEmail',
          //   name: 'generalAlarmEmail',
          //   component: () =>
          //     import('./views/setting/alarm/email'),
          //   meta: {
          //     title: i18n.t('menu.email'),
          //     category: 'alarm'
          //   }
          // },
          // {
          //   path: 'alarmMobile',
          //   name: 'generalAlarmMobile',
          //   component: () =>
          //     import('./views/setting/alarm/mobile'),
          //   meta: {
          //     title: i18n.t('menu.mobile'),
          //     category: 'alarm'
          //   }
          // },
          {
            path: "rechargePay",
            name: "generalRechargePay",
            component: () => import("./views/setting/recharge/pay"),
            meta: {
              title: i18n.t("menu.pay"),
              category: "recharge",
            },
          },
          // {
          //   path: 'rechargeRecord',
          //   name: 'generalRechargeRecord',
          //   component: () =>
          //     import('./views/setting/recharge/record'),
          //   meta: {
          //     title: i18n.t('menu.record'),
          //     category: 'recharge'
          //   }
          // },
          {
            path: "rate",
            name: "generalRate",
            component: () => import("./views/setting/rate"),
            meta: {
              title: i18n.t("menu.rate"),
              icon: "icon-fee",
            },
          },
          {
            path: "firmware",
            name: "generalFirmware",
            component: () => import("./views/setting/firmware"),
            meta: {
              title: i18n.t("menu.firmware"),
              icon: "icon-firmwareSet",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/404",
    meta: {
      role: "all",
    },
    component: () => import("./views/errorPage/404"),
  },
];

const router = new Router({
  linkActiveClass: "active",
  // mode: 'history',  // 使用 History 模式
  // 将定义好的路由数组传进路由构造函数中
  routes,
});
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   // 处理控制台重定向报错
// return originalPush.call(this, location).catch(err => err)
// // return originalPush.call(this, location)
// }

// 路由守卫，即路由跳转的一个回调函数， 即每次路由跳转时都会触发守卫里面的函数
// (1)可做登录限制，即函数里面放置判断是否有登录的代码块，即if(login){next()}
router.beforeEach((to, from, next) => {
  // console.log(to)
  // 初始进入时尚未存储登录信息
  if (
    !Store.state.user.secret ||
    !Store.state.user.token ||
    Store.state.user.role === undefined
  ) {
    // console.log(123123123,Store.state.user,to.query);
    let urlQuery = to.query,
      cookies = cookie.getCookie("secret", "token", "role",'pprAuth');
    if (urlQuery.secret) {
      // 从路由获取登录信息
      sessionStorage.setItem("secret", urlQuery.secret);
      sessionStorage.setItem("token", urlQuery.token);
      sessionStorage.setItem("role", urlQuery.role);
      sessionStorage.setItem("pprAuth", urlQuery.pprAuth);
      Store.commit("saveAuth", {
        secret: urlQuery.secret,
        token: urlQuery.token,
        role: urlQuery.role,
        pprAuth: urlQuery.pprAuth,
      });
    sessionStorage.setItem("isLogin", true);
    } else if (sessionStorage.getItem("secret")) {
      // 从sessionStorage获取登录信息
      Store.commit("saveAuth", {
        secret: sessionStorage.getItem("secret"),
        token: sessionStorage.getItem("token"),
        role: sessionStorage.getItem("role"),
        pprAuth: sessionStorage.getItem("pprAuth"),
      });
    } 
    else if (cookies.secret&&sessionStorage.getItem("isLogin")) {
      // 从cookie获取登录信息
      // if(cookies.role == "undefined"){
      //   cookie.delCookie('token', 'secret', 'role')
      //   sessionStorage.removeItem('token')
      //   sessionStorage.removeItem('secret')
      //   sessionStorage.removeItem('role')
      // }else{
      // console.log("cookies不是",cookies)
      sessionStorage.setItem("secret", cookies.secret);
      sessionStorage.setItem("token", cookies.token);
      sessionStorage.setItem("role", cookies.role);
      sessionStorage.setItem("pprAuth", cookies.pprAuth);
      Store.commit("saveAuth", {
        secret: cookies.secret,
        token: cookies.token,
        role: cookies.role,
        pprAuth: cookies.pprAuth,
      });
      // }
    } 
    else if (!to.fullPath.startsWith("/entry")) {
      // 跳转登录页
      // Message.error({
      //   message: i18n.t(`errCode.10`),
      // });
      next({
        path: "/entry",
        query: {
          redirect: to.fullPath,
        },
      });
      return;
    } else {
      next();
      return;
    }
  }
  //用户点击浏览器回退，重置route和权限字段isNewEdition
  if (to.matched.length > 0) {
    if (
      to.matched[0].path === "/adminNew" ||
      to.matched[0].path === "/generalNew"
    ) {
      cookie.setCookie("isNewEdition", true);
      Store.commit("saveEditionType", {
        isNewEdition: true,
      });
    } else if (
      to.matched[0].path === "/admin" ||
      to.matched[0].path === "/general"
    ) {
      cookie.setCookie("isNewEdition", false);
      Store.commit("saveEditionType", {
        isNewEdition: false,
      });
    }
  }
  Store.commit("saveRoute", "");
  //  if (to.path === "/adminNew/home"||to.path === "/generalNew/home") {
  //   console.log("新")
  //   cookie.setCookie("isNewEdition", true);
  //   Store.commit("saveEditionType", {
  //     isNewEdition: true,
  //   });
  // } else if (to.path === "/admin/home"||to.path === "/general/home") {
  //   console.log("旧")
  //   cookie.setCookie("isNewEdition", false);
  //   Store.commit("saveEditionType", {
  //     isNewEdition: false,
  //   });
  // }
  // console.log(cookie.getCookie("isNewEdition"), "我是cooke")

  // console.log(Store.state.user.isNewEdition, "我是store")
  // console.log(Store.state.user.route)
  // 根据权限定位主页
  // let home = routes.find(item => {
  //   return item.meta && item.meta.role.indexOf(Store.state.user.role - 0) > -1
  // })
  let home;
  // 判断是否是电站业主,是否跳到新版本
  if (Store.state.user.role == 0 || Store.state.user.role == 5) {
    if (Store.state.user.isNewEdition) {
      home = routes.find((item) => {
        return (
          item.meta &&
          item.meta.role.indexOf(Store.state.user.role - 0) > -1 &&
          item.meta.version == 1
        );
      });
      // console.log("新版普通用户home", home)
      home.path = "/generalNew";
    } else {
      home = routes.find((item) => {
        return (
          item.meta &&
          item.meta.role.indexOf(Store.state.user.role - 0) > -1 &&
          item.meta.version == 0
        );
      });
      // console.log("旧版普通用户home", home)
      home.path = "/general";
    }
  }
  // 判断是否是管理员,是否跳到新版本
  if (
    Store.state.user.role == 1 ||
    Store.state.user.role == 2 ||
    Store.state.user.role == 3
  ) {
    // home = routes.find(item => {
    //   return item.meta && item.meta.role.indexOf(Store.state.user.role - 0) > -1
    // })
    if (Store.state.user.isNewEdition) {
      home = routes.find((item) => {
        return (
          item.meta &&
          item.meta.role.indexOf(Store.state.user.role - 0) > -1 &&
          item.meta.version == 1
        );
      });
      // console.log("新版经销商home", home)
      home.path = "/adminNew";
    } else {
      home = routes.find((item) => {
        return (
          item.meta &&
          item.meta.role.indexOf(Store.state.user.role - 0) > -1 &&
          item.meta.version == 0
        );
      });
      // console.log("旧版经销商home", home)
      home.path = "/admin";
    }
  }
  // 判断是否是内部管理账号,是否跳到新版本
  if (
    Store.state.user.role == 15
  ) {
    home = routes.find((item) => {
      return (
        item.meta &&
        item.meta.role.indexOf(Store.state.user.role - 0) > -1 &&
        item.meta.version == 1
      );
    });
    home.path = "/adminNewStatr";
  }

  // 保存路由信息
  if (!Store.state.user.route) {
    // console.log(to, from, next,home,home.children,"home.childrenhome.children")
    Store.commit("saveRoute", home.children);
  }

  // 无匹配页
  if (!to.matched.length) {
    if (to.fullPath.startsWith("/home")) {
      // 重定向首页
        next({
          path: home.path,
        });
      // sessionStorage.setItem("disPermissionsLogo", false);
      // if(Store.state.user.role==2&&Store.state.user.isNewEdition&&!sessionStorage.getItem("moduleArr")){
      //   sessionStorage.removeItem('moduleArr')
      //   sessionStorage.removeItem('firstPageArr')
      //   sessionStorage.removeItem('secPageArr')
      //   sessionStorage.removeItem('buttonArr')
      //   Request.get("queryAccountInfo").then(res => {
      //     if (res.err === 0&&res.dat.permission.length>0) {
      //       var moduleArr=[],firstPageArr=[],secPageArr=[],buttonArr=[]
      //       res.dat.permission.forEach(item => {
      //         if(item.isCheck)
      //          moduleArr.push(item.action);
      //         if(item.buttons){
      //             for (var i = 0, length = item.buttons.length; i < length; i++) {
      //               if(item.buttons[i].isCheck){
      //                 buttonArr.push(item.buttons[i].action)
      //               }
      //             }
      //         }
      //         item.first_menus.forEach(firstItem => {
      //           if(firstItem.isCheck)
      //           firstPageArr.push(firstItem.action);
      //           if(firstItem.buttons){
      //               for (var i = 0, length = firstItem.buttons.length; i < length; i++) {
      //                 if(firstItem.buttons[i].isCheck){
      //                   buttonArr.push(firstItem.buttons[i].action)
      //                 }
      //               }
      //           }
      //           firstItem.second_menus.forEach(secItem => {
      //           if(secItem.isCheck)
      //           secPageArr.push(secItem.action);
      //           if(secItem.buttons){
      //               for (var i = 0, length = secItem.buttons.length; i < length; i++) {
      //                 if(secItem.buttons[i].isCheck){
      //                   buttonArr.push(secItem.buttons[i].action)
      //                 }
      //               }
      //           }
      //         })
      //         })
      //       });
      //       sessionStorage.setItem("moduleArr", JSON.stringify(moduleArr));
      //       sessionStorage.setItem("firstPageArr", JSON.stringify(firstPageArr));
      //       sessionStorage.setItem("secPageArr", JSON.stringify(secPageArr));
      //       sessionStorage.setItem("buttonArr", JSON.stringify(buttonArr));
      //       sessionStorage.setItem("disPermissionsLogo", true);
      //     }
      //     var arr = sessionStorage.getItem("moduleArr")?JSON.parse(sessionStorage.getItem("moduleArr")):[]
      //     var pathValue = ''
      //     console.log(arr,"arrarrarr")
      //     if(arr.includes('overview')){
      //       pathValue='adminNew/home'
      //     }else if(arr.includes('device_manag')){
      //       pathValue='/adminNew/device'
      //     }else if(arr.includes('account_manag')){
      //       pathValue='/adminNew/account'
      //     }else if(arr.includes('alarm_manag')){
      //       pathValue='/adminNew/alarm'
      //     }else if(arr.includes('system_settings')){
      //       pathValue='/adminNew/setting'
      //     }else{
      //       pathValue='adminNew/home'
      //     }
      //     next({
      //       path: pathValue,
      //     });
      //   }).catch(() => {
      //     next({
      //       path: home.path,
      //     });
      //   })
      // }else{
      //   next({
      //     path: home.path,
      //   });
      // }
    } else {
      // 404页
      next("/404");
    }
  } else {
    // 若存有登录信息跳过登录页
    // if (to.fullPath.startsWith('/entry')) {
    //   next('/home')
    // } else if (!to.fullPath.startsWith(home.path) && (!to.meta || to.meta.role !== 'all')) {
    //   next('/401')
    // } else {
    next();
    // }
  }
  // if (to.path === "/404") {
  //   Sentry.captureException(new Error('页面404'));
  //   return
  // }
  // Filter.captureMessage("", {
  //   toTitle: to.meta.title,
  //   toPath: to.path,
  //   fromTitle: from.meta.title,
  //   fromPath: from.path,
  // });
});

export default router;
